import { Component, input, InputSignal } from '@angular/core';

import { StaticBlockSection } from '@core/cms/landing.cms';
import { CmsBtn } from '@shared/ui/cms-btn/cms-btn';
import { CmsImage } from '@shared/ui/cms-image/cms-image';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/**
 * Renders a `ComponentSectionStaticBlock`: rich content with an optional list of marked items, a
 * background image, and a CTA button.
 */
@Component({
    selector: 'cms-static-block',
    imports: [CmsBtn, CmsImage, TrustHtmlPipe],
    templateUrl: './static-block.html',
    styleUrl: './static-block.scss',
})
export class CmsStaticBlock {
    public readonly section: InputSignal<StaticBlockSection> = input.required<StaticBlockSection>();
}
